import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { dateTimeConverter } from '../../utils/dateTimeConverter';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { IconEdit, IconToggleLeft, IconToggleRight } from '@tabler/icons-react';
import SubmittedIssueByUserModal from './Components/SubmittedIssueByUserModal';
import RewardListOfUserModal from './Components/RewardListOfUserModal';
import DeviceDonutChart from './Components/DeviceDonutChart';
import ReferredBarChart from './Components/ReferredBarChart';
import ClickLocationTable from './Components/ClickLocationTable';
import CreditModal from './Components/CreditModal';
import DebitModal from './Components/DebitModal';
import { toast } from 'sonner';
import UpdateUserDetails from './Components/UpdateUserDetails';
import BankList from './Components/BankList';

const UserDetails = () => {
    const { userId } = useParams();
    const [userDetails, setUserDetails] = useState({});
    const [analyticsCardsData, setAnalyticsCardsData] = useState(null);
    const [donutChartData, setDonutChartData] = useState(null);
    const [loadingStates, setLoadingStates] = useState({
        analyticsCardsData: true
    })

    const getUserDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.useDetailsById + userId);
        loadingHide();
        if (resp.responseCode === 200) {
            setUserDetails(resp.data);
        } else {
            setUserDetails({});
        }
    }


    async function getAnalyticsCardsData() {
        setLoadingStates((prev) => ({ ...prev, analyticsCardsData: true }));
        let resp = await getApi(urlApi.userAnalyticsCard + userId + "/" + userDetails?.defaultOrganizationId);
        setLoadingStates((prev) => ({ ...prev, analyticsCardsData: false }));
        if (resp.responseCode === 200) {
            setAnalyticsCardsData(resp.data);
        } else {
            setAnalyticsCardsData(null);
        }
    }

    async function getDeviceDonutChart() {
        setLoadingStates((prev) => ({ ...prev, deviceDonutChart: true }));
        let resp = await getApi(urlApi.userClickDeviceData + userId + "/" + userDetails?.defaultOrganizationId);
        setLoadingStates((prev) => ({ ...prev, deviceDonutChart: false }));
        if (resp.responseCode === 200) {
            setDonutChartData(resp.data);

        } else {
            setDonutChartData(null);
        }
    }

    useEffect(() => {
        getUserDetails();
        return () => { }
    }, [userId]);

    useEffect(() => {
        if (userDetails?.defaultOrganizationId) {
            getAnalyticsCardsData();
            getDeviceDonutChart();
        }
        return () => { }
    }, [userDetails, userId])

    async function updateStatus(status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateUserStatus}${userId}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getUserDetails();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <Layout>
            <div className="flex flex-wrap !gap-6 items-center justify-around mb-2">
                <img src={userDetails?.profilePic} alt="" className='h-40 aspect-square rounded-md object-contain' />
                <div>
                    <p className='text-sm text-gray-600'>Name : <span className='font-medium'>{userDetails.name}</span> </p>
                    <p className='text-sm text-gray-600'>Email : <span className='font-medium'>{userDetails.email ?? "--"}</span></p>
                    <p className='text-sm text-gray-600'>Phone :  <span className='font-medium'>{userDetails.phone}</span></p>
                    <div className='flex items-center !gap-3 text-sm text-gray-600'>Status: <ConfirmationModal onConfirm={() => updateStatus(userDetails?.status == 1 ? 2 : 1)} confirmationText={'Are you sure want to update?'} buttonComponent={userDetails?.status == 1 ? <IconToggleRight color='green' /> : <IconToggleLeft color='red' />} /> </div>
                </div>
                <div>
                    <p className='text-sm text-gray-600'>Login By : <span className='font-medium'>{userDetails.loginBy == 1 ? "Mobile" : "Email"}</span></p>
                    <p className='text-sm text-gray-600'>Created At :<span className='font-medium'> {dateTimeConverter(userDetails?.createdAt)}</span></p>
                    <p className='text-sm text-gray-600'>Updated :<span className='font-medium'> {dateTimeConverter(userDetails?.updatedAt)}</span></p>
                    <p className='text-sm text-gray-600'>Last Login :<span className='font-medium'> {dateTimeConverter(userDetails?.lastLogin)}</span></p>
                </div>
                <div>
                    <p className='text-sm text-gray-600'>Company : <span className='font-medium'>{userDetails?.company ?? "--"}</span></p>
                    <p className='text-sm text-gray-600'>Website : <span className='font-medium'>{userDetails?.website ?? "--"}</span></p>
                    <p className='text-sm text-gray-600'>Earning : <span className='font-medium'>₹{userDetails?.balance?.toFixed(2)}</span></p>
                </div>
            </div>

            <div className="flex !gap-5 flex-wrap mb-3">
                <UpdateUserDetails userData={userDetails} callback={() => getUserDetails()}
                    buttonComponent={<button className='bg-pink-600 !px-5 !py-1.5 rounded-full text-sm text-white'> Update</button>} />
                <RewardListOfUserModal userData={userDetails} />
                <SubmittedIssueByUserModal userData={userDetails} />
                <Link className='bg-purple-700 !px-5 !py-1.5 rounded-full text-sm text-white' to={"/links/" + userId} state={userDetails} >Links</Link>
                <Link className='bg-orange-700 !px-5 !py-1.5 rounded-full text-sm text-white' to={"/qr-codes/" + userId} state={userDetails} >QRs</Link>
                <Link className='bg-sky-700 !px-5 !py-1.5 rounded-full text-sm text-white' to={"/pages/" + userId} state={userDetails} >Pages</Link>
                <Link className='bg-teal-700 !px-5 !py-1.5 rounded-full text-sm text-white' to={"/business-cards/" + userId} state={userDetails} >Business Cards</Link>
                <BankList userData={userDetails} />
                <CreditModal userData={userDetails} callback={() => getUserDetails()} />
                <DebitModal userData={userDetails} callback={() => getUserDetails()} />
            </div>

            <div className="grid grid-cols-2">
                <div className="col-span-1 h-full">
                    <DeviceDonutChart chartData={donutChartData} loadingState={loadingStates.deviceDonutChart} />
                </div>
                <div className="col-span-1">
                    <div className="grid grid-cols-2 gap-3 mb-5">
                        <div className='col-span-2'>  <StatsCard title={"ENGAGEMENT"} loadingState={loadingStates.analyticsCardsData} icon={"/images/users.svg"} value={analyticsCardsData?.engagements || '0'} colorCode={'text-[#144EE3]'} accentColor={'bg-[#144EE310]'} /></div>
                        <StatsCard title={"LINK CLICKED"} loadingState={loadingStates.analyticsCardsData} icon={"/images/link.svg"} value={analyticsCardsData?.linkClicked || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />
                        <StatsCard title={"QR CODE SCANS"} loadingState={loadingStates.analyticsCardsData} icon={"/images/qr-yellow.svg"} value={analyticsCardsData?.qrCodeScanned || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />
                        <StatsCard title={"PAGES CLICKED"} loadingState={loadingStates.analyticsCardsData} icon={"/images/page-click.svg"} value={analyticsCardsData?.pageClicked || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />
                        <StatsCard title={"BUSINESS CARDS CLICKED"} loadingState={loadingStates.analyticsCardsData} icon={"/images/page-click.svg"} value={analyticsCardsData?.businessCardClicked || '0'} colorCode={'text-[#7013a2]'} accentColor={'bg-[#7013a21a]'} />
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 mb-5 gap-3">
                <div className="col-span-1">
                    <ReferredBarChart userId={userId} organizationId={userDetails?.defaultOrganizationId} />
                </div>
                <div className="col-span-1">
                    <ClickLocationTable userId={userId} organizationId={userDetails?.defaultOrganizationId} />
                </div>
            </div>
        </Layout>
    )
}

export default UserDetails;

export const StatsCard = ({ title, icon, value, colorCode, accentColor, loadingState }) => {
    return (
        <div className={`${accentColor} py-3 px-5 rounded-lg text-center`}>
            <img src={process.env.PUBLIC_URL + icon} alt="" />
            {loadingState ? <div className={`animate-pulse ${accentColor} rounded-lg w-[100%] h-[38px]`}></div> : <p className={`mb-0 text-[25px] font-bold text-[var(--black)]`}>{value}</p>}
            <p className={`mb-0 text-[12px] font-semibold ${colorCode}`}>{title}</p>

        </div>
    )
}